__turbopack_context__.v({
  "btn": "EditFormControls-module-scss-module__hsv9Vq__btn",
  "closeIcon": "EditFormControls-module-scss-module__hsv9Vq__closeIcon",
  "controls": "EditFormControls-module-scss-module__hsv9Vq__controls",
  "mobileCloseButton": "EditFormControls-module-scss-module__hsv9Vq__mobileCloseButton",
  "root": "EditFormControls-module-scss-module__hsv9Vq__root",
  "title": "EditFormControls-module-scss-module__hsv9Vq__title",
});
